// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PartnerScoreApiModel from "../api-model/PartnerScoreApiModel.bs.js";

function actionDetailsDecoder(score) {
  return {
          action_state: Belt_Option.getWithDefault(score.actionState, ""),
          action_threshold: Belt_Option.getWithDefault(score.actionThreshold, 0),
          action_text: Belt_Option.getWithDefault(score.actionText, "")
        };
}

function execute(json) {
  var res = DeccoUtils$Catalyst.resolveResult(PartnerScoreApiModel.t_decode(json), "PartnerScoreEntityMapper.res");
  return List.map((function (score) {
                return {
                        name: score.scoreName,
                        value: score.scoreValue,
                        locked_state: score.scoreState,
                        thresholds: score.scoreThresholds,
                        action_value: Belt_Option.getWithDefault(score.scoreActionValues, /* [] */0),
                        action_details: actionDetailsDecoder(score)
                      };
              }), res);
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
